import { isNonEmpty } from '@sgme/fp';
import classNames from 'classnames';
import { FC } from 'react';
import type { KycDetail, KycScoreStatus } from 'state/secondaryMarket/shared/kyc/kyc.model';

import { KycScoreErrorModal } from './KycScoreErrorModal';

export type KycScoreProps = {
  className?: string;
  status: KycScoreStatus;
  details: readonly KycDetail[] | undefined;
};

export const KycScore: FC<KycScoreProps> = ({ status, details, className }) => {
  const hasDetails = isNonEmpty(details);
  if (status === 'green' || !hasDetails) {
    return null;
  }
  return (
    <div className={classNames('border px-2 py-1 align-items-center', className)} id="kyc-score" data-e2e="kyc-score">
      <KycScoreErrorModal status={status} details={details} />
    </div>
  );
};

KycScore.displayName = 'KycScore';
